import React from 'react';

import { Image } from 'components/Image';

export const MaximizeBackground = () => {
  return (
    <div className="use-case-background">
      <Image
        imagePath="homepage/maximize-productivity.png"
        alt="Illustration picture for the use case Maximize ProductivityAnd Engagement"
        loading="lazy"
      />
    </div>
  );
};
